export default {
    CLOSE_MODAL(state) {
        state.modal.active = false;
        state.current = {
            currency: '',
            payment_ref: '',
            client_secret: '',
            payment_type: '',
            to_pay: 0,
            vat: 0,
            entity: '',
            gateway: '',
            payload: {}
        }
    },
    TOPUP(state, payment) {
        state.current = payment;
        state.modal.active = true;
    },
    UPDATE_UNFINISHED(state, payment) {
        if(!payment.subtotal) payment.subtotal = payment.total - payment.vat;
        state.current = payment;
        state.modal.active = true;
    },

    PAYMENTS_APPEARANCE(state, style) {
        state.paymentsAppearance = style;
    },
    CLIENT_PAYMENTS(state, response) {
        state.clientPayments = response.data.payments;
        state.paymentsLoading = false;
    },
    /* Booking */
    PAY_PENDING(state, payment) {
        if(!payment.subtotal) payment.subtotal = payment.total - payment.vat;
        state.current = payment;
        state.modal.active = true;
    },
}
